import { useEffect, useState } from "react";

const useIsOtherContained = (val: { text?: string }) => {
  const [isOtherContained, setIsOtherContained] = useState(false);

  useEffect(() => {
    let isContained = ["other", "others"].some((keyword) =>
      val?.text?.toLocaleLowerCase().includes(keyword),
    );
    setIsOtherContained(isContained);
  }, [val]);

  return isOtherContained;
};

export default useIsOtherContained;
